import { Route } from '@angular/router';
import { ReferralsGuard } from '../../../app/referrals-guard.guard';
import { useSpanishForLegacyMy } from '../i18n';

export const localeMyRoute: Route = {
    path: 'my',
    loadChildren: () => import('../../../app/my/my.module').then((m) => m.MyModule),
    canActivate: [ReferralsGuard],
};

export const legacyMyRoute: Route = {
    path: 'my',
    loadChildren: () => import('../../../app/my/my.module').then((m) => m.MyModule),
    canActivate: [useSpanishForLegacyMy, ReferralsGuard],
};
